module.exports = __webpack_public_path__ + "media/images/svg/facebook-fb296ce9a7632c8a5ff8446bd71cf9eb.svg";